import * as yup from 'yup';

import { propertyContractBaseSchema } from '@/features/Contract/Property/contractBaseSchema';
import { locales } from '@/features/validation/locales';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';
import { OPTIONAL_ROLE, Role, useClientStore } from '@/features/Clients';

yup.setLocale(locales);

export const ContractPersonSchema = yup.object({
  erbe: yup.string().default(''),
  wagnisSportarten: yup.boolean().default(false),
  wagnisSportartenMemo: yup
    .string()
    .default('')
    .when('wagnisSportarten', {
      is: (val: boolean) => val,
      then: yup.string().required(),
    }),
});

export const getContractPersonSchemaForRole = (
  role: Role = 'versichertePerson' as Role,
) =>
  yup.lazy(() => {
    if (useClientStore().hasClientWithRole(role)) {
      return ContractPersonSchema;
    }

    return yup.string().default(undefined).nullable();
  });

export const weitereVersicherungSchema = yup.object({
  bestehenWeitereVersicherungen: yup.boolean().default(false),
  gesellschaft: yup
    .string()
    .default('')
    .when('bestehenWeitereVersicherungen', {
      is: (val: boolean) => val,
      then: yup.string().required(),
    }),
  versicherungsnummer: yup
    .string()
    .default('')
    .when('bestehenWeitereVersicherungen', {
      is: (val: boolean) => val,
      then: yup.string().required(),
    }),
});

export const weitereAngabenSchema = yup.object({
  dynamik: yup.boolean().default(false),
});

export const contractSchema = propertyContractBaseSchema.concat(
  yup.object({
    einverstaendniserklaerungSEE: yup
      .boolean()
      .default(false)
      .notOneOf([false]),
    versichertePerson: getContractPersonSchemaForRole(),
    versichertePerson2: getContractPersonSchemaForRole(
      'versichertePerson2' as OPTIONAL_ROLE,
    ),
    versichertePerson3: getContractPersonSchemaForRole(
      'versichertePerson3' as OPTIONAL_ROLE,
    ),
    versichertePerson4: getContractPersonSchemaForRole(
      'versichertePerson4' as OPTIONAL_ROLE,
    ),
    versichertePerson5: getContractPersonSchemaForRole(
      'versichertePerson5' as OPTIONAL_ROLE,
    ),
    versichertePerson6: getContractPersonSchemaForRole(
      'versichertePerson6' as OPTIONAL_ROLE,
    ),
    preliminaryContractLink: yup.string().nullable().default(null),
    weitereVersicherung: weitereVersicherungSchema,
    weitereAngaben: weitereAngabenSchema,
  }),
);

export type ContractStore = yup.Asserts<typeof contractSchema>;

export const useUnfContractStore = genericStoreFactory(
  () => contractSchema.getDefault() as ContractStore,
  'UnfContractStore',
);
